import sanitizeHtml from "sanitize-html";

compiler('[disable-button-on-submit]', (button) => {
  const form = button.closest("form");
  const buttonOriginalText = button.innerHTML;

  form.addEventListener("submit", function(){
    button.disabled = true;
    let buttonText = buttonOriginalText;
    if (button.hasAttribute("data-text-during-wait")) {
      buttonText = button.dataset.textDuringWait;
    }
    button.innerHTML = "<i class=\"fa-solid fa-spinner fa-spin me-1\"></i>" + sanitizeHtml(buttonText);
  });

  $(form).on('ajax:complete', function(event) {
    button.disabled = false;
    button.innerHTML = sanitizeHtml(buttonOriginalText);
  });
});
